import { render, staticRenderFns } from "./ComponentSnapshotTab.vue?vue&type=template&id=2034f1f7"
import script from "./ComponentSnapshotTab.vue?vue&type=script&lang=js"
export * from "./ComponentSnapshotTab.vue?vue&type=script&lang=js"
import style0 from "./ComponentSnapshotTab.vue?vue&type=style&index=0&id=2034f1f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports